export default "__VITE_ASSET__Bfc_fIQY__"